module.exports = __webpack_public_path__ + "b2643e520af046b150524b735952b49f.gif";